// Basic
import PropTypes from 'prop-types';
// Libs
import { useNavigate } from 'react-router-dom';
// Components
import ChartCard from '@/common-utils/components/renders/chartsCards/ChartCard';
import PieChartSkeleton from '../../common/PieChartSkeleton';
import CardRedirection from '../../common/CardRedirection';
import PieChartCustom from '@/common-utils/components/renders/charts/PieChartCustom';
// Common
import CONTRACTS_STATS_FIELDS from '../../../fields/ContractsStatsFields';
import RouteUrls from '@/app/root/enums/RouteUrls';
// Lang
import { nsDashboard } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.dashboardData
 * @returns {JSX} ContractsApplicationsChart
 */
function ContractsApplicationsChart({ dashboardData }) {
    // Hooks
    const navigate = useNavigate();

    return (
        <>
            {dashboardData.contracts?.isFetching &&
                <PieChartSkeleton />
            }
            {!dashboardData.contracts?.isFetching && (
                <ChartCard
                    title='charts.contracts.applications.title'
                    tooltipEntity='charts.contracts.applications.tooltip'
                    namespace={nsDashboard}
                >
                    {dashboardData.contracts?.data && !dashboardData.contracts?.error && (
                        <PieChartCustom
                            data={dashboardData.contracts?.data}
                            dataKey={CONTRACTS_STATS_FIELDS.APPLICATION_BREAKDOWN.key}
                            chartKey='application'
                            valueKey='count'
                            namespace={nsDashboard}
                        />
                    )}
                    {dashboardData.contracts?.error && (
                        <CardRedirection
                            buttonEntity='redirection.contracts'
                            namespace={nsDashboard}
                            onClick={() => { navigate(RouteUrls.SEARCH_CONTRACTS.url); }}
                        />
                    )}
                </ChartCard>
            )}
        </>
    );
}

ContractsApplicationsChart.propTypes = {
    dashboardData: PropTypes.object.isRequired
};

export default ContractsApplicationsChart;